import React, { Component } from 'react'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import I18n from '../lib/i18n'
import fetchContentGroupsData from '../lib/fetchContentGroupsData'
import withTracker from '../lib/withTracker'
import withStore from '../lib/withStore'
import withHeader from '../lib/withHeader'
import SearchBar from '../components/SearchBar'
import ChanelLogoBlack from '../images/chanel-logo-black.svg'
import * as StyledComponent from '../styles'
import Analytics from '../lib/analytics'

class Explore extends Component {
  constructor(props) {
    super(props)
    this.state = {
      keyword: ''
    }
  }

  componentDidMount() {
    // fetch for content_groups if it is not already in store
    _.isEmpty(this.props.store.content_groups) &&
    fetchContentGroupsData().then(content_group_data => {
      this.saveToStore(content_group_data)
    })
  }

  submitSearch = value => {
    // don't go to the product search result page if the keyword length is less than 3
    if (value.length > 2) {
      this.props.history.push(`/${I18n.currentLocale()}/search?q=${value}`)
    }
  }

  browseProductGroups = () => {
    this.props.history.push(`/${I18n.currentLocale()}/products`)

    // track event
    Analytics.event({ category: 'Minicart - Explore', action: 'Clicked Browse All Products' })
  }

  saveToStore = (state, cb) => {
    this.props.store.save({ ...state }, cb)
  }

  render() {
    return <StyledComponent.PageContainer id='scroll-view' alignCenter>
      <StyledComponent.Explore>
        <img className='logo' alt='' src={ChanelLogoBlack} />
        <SearchBar
          className='search-bar'
          onChange={() => {}}
          onSearch={this.submitSearch}
          onClear={() => {}}
          placeholder={I18n.t('containers.explore.search_placeholder')}
        />
        {/* <div className='hint'>{I18n.t('containers.explore.hint')}</div> */}
        {/* <div>
          <a className='tutorial' href='#'>{I18n.t('containers.explore.tutorial')}</a>
        </div> */}
        <StyledComponent.BrowseAllProductsBtn className="browse-all-products-btn" onClick={this.browseProductGroups}>
          {I18n.t('containers.explore.browse_all_products')}
        </StyledComponent.BrowseAllProductsBtn>
      </StyledComponent.Explore>
    </StyledComponent.PageContainer>
  }
}

export default withTracker(withStore(withRouter(withHeader(Explore))), {
  title: I18n.t('containers.explore.title')
})



// WEBPACK FOOTER //
// ./src/containers/Explore.js